// app/javascript/controllers/form_updater_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
 
  static targets = [
      "typeOfClass"]

  static values = {
    classroomSourceId: Number,
    hasErrors: Boolean
  }

  connect() {
    if (this.hasErrorsValue) return;

    this.update()
  }

  update() {
    const typeId = this.typeOfClassTarget.value
    let url = `/schools/setup/classroom/update-form/${typeId}`

    // Try to get the value directly from the found element
    const dataElement = document.querySelector('[data-driving-school-classroom-program-setup-classroom-source-id-value]')
    if (dataElement) {
      const sourceId = dataElement.getAttribute('data-driving-school-classroom-program-setup-classroom-source-id-value')
      console.log("Source ID from direct attribute:", sourceId)

      // Store this value in a class property so we can use it later
      this.sourceId = parseInt(sourceId, 10)
      url = url + '?copy_from_classroom_id=' + this.sourceId
    }
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
  }

}
